import React, { useMemo } from 'react';
import { Pressable, Text, Platform } from 'react-native';
import { Monitor, X } from 'lucide-react-native';
import { WEB_HOVER_TRANSITION_STYLE } from '../../../src/shared/constants/animations';
import {
  GROUP_HERO_BANNER_ACTION_ICON_COLOR,
} from '../GroupHeroBanner/GroupHeroBanner.constants';
import { SQUAD_TV_MODE_COPY, SQUAD_TV_MODE_TEST_IDS } from '../../../src/worldcup/constants/squadTvMode.constants';
import { getSquadTvModeToggleStyles } from './SquadTvModeToggle.styles';

interface SquadTvModeToggleProps {
  isTvModeActive: boolean;
  onPress: () => void;
  /** Icon-only circular chip (matches share/info on the banner). */
  iconOnly?: boolean;
}

export const SquadTvModeToggle: React.FC<SquadTvModeToggleProps> = ({
  isTvModeActive,
  onPress,
  iconOnly = false,
}) => {
  const styles = useMemo(() => getSquadTvModeToggleStyles(), []);
  const label = isTvModeActive ? SQUAD_TV_MODE_COPY.EXIT_TV_MODE : SQUAD_TV_MODE_COPY.ENTER_TV_MODE;
  const a11yLabel = isTvModeActive
    ? SQUAD_TV_MODE_COPY.EXIT_TV_MODE_A11Y
    : SQUAD_TV_MODE_COPY.ENTER_TV_MODE_A11Y;
  const Icon = isTvModeActive ? X : Monitor;
  const iconColor = GROUP_HERO_BANNER_ACTION_ICON_COLOR;

  return (
    <Pressable
      testID={SQUAD_TV_MODE_TEST_IDS.toggle}
      accessibilityRole="button"
      accessibilityLabel={a11yLabel}
      onPress={onPress}
      style={({ pressed, hovered }) => [
        iconOnly ? styles.buttonIcon : styles.buttonWithLabel,
        Platform.select({ web: WEB_HOVER_TRANSITION_STYLE }),
        pressed && styles.buttonPressed,
        hovered && Platform.OS === 'web' && styles.buttonHover,
      ]}
    >
      <Icon size={16} color={iconColor} strokeWidth={2.2} />
      {iconOnly ? null : <Text style={styles.label}>{label}</Text>}
    </Pressable>
  );
};
